export default __webpack_public_path__ + "static/media/fast-n-final.0efb1294.jpeg";